/* unplugin-vue-components disabled */import { render } from "./xLayout.vue?vue&type=template&id=2c043cf3"
import script from "./xLayout.vue?vue&type=script&lang=jsx"
export * from "./xLayout.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__